module.exports = __webpack_public_path__ + "img/tenet_icon_zhuan@2x.12b10180.png";